import { useRef, useEffect, useCallback } from 'react';

function useMountedFlag() {
  const isMountedRef = useRef(false);

  useEffect(() => {
    isMountedRef.current = true;

    return () => {
      isMountedRef.current = false;
    };
  }, []);

  return useCallback(() => isMountedRef.current, []);
}

export { useMountedFlag };
